export const environment = {
  production: false,
  hmr: false,
  env: 'staging',
  apiUrl: 'https://staging.getmindright.io/api/v1',
  socketUrl: 'https://staging.getmindright.io'
};
